import { render, staticRenderFns } from "./EventRegexCreate.vue?vue&type=template&id=49ac6e97"
import script from "./EventRegexCreate.vue?vue&type=script&lang=js"
export * from "./EventRegexCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports